import { toggleMark } from "../../commands/commands";
import { enableUrlDialog } from "./plugins";
export const toggleUrlMark = (schema) => {
    const cmd = toggleMark(schema.marks.link);
    return {
        ...cmd,
        enable: (state) => !state.selection.empty,
        run: (state, dispatch, view) => {
            if (cmd.active(state)) {
                cmd.run(state, dispatch, view);
                return;
            }
            dispatch(enableUrlDialog(state.tr));
        },
    };
};
